<template>
  <div
    v-if="enabled"
    class="arc"
  >
    <arc-el
      :border-color="computedBorderColor"
      :rotation="computedRotation"
      :position-x="computedPositionX"
      :position-y="computedPositionY"
      parallax
    />
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import ArcEl from 'beisheim/components/elements/arc-el'

function getRandomIntegerInRange (min, max) {
  return Math.floor(Math.random() * (max - min) + min)
}

export default {
  components: {
    ArcEl
  },
  props: {
    borderColor: VueTypes.oneOf(['bildung', 'gesundheit', 'kultur', 'sport', '']).def(''),
    rotation: VueTypes.integer,
    positionX: VueTypes.integer,
    positionY: VueTypes.integer,
    randomRangePositionX: VueTypes.oneOfType([
      VueTypes.object,
      VueTypes.array
    ]).def({ min: 0, max: 100 }),
    randomRangePositionY: VueTypes.shape({
      min: VueTypes.integer,
      max: VueTypes.integer
    }).def({ min: -7, max: 7 }),
    randomRangeRotation: VueTypes.shape({
      min: VueTypes.integer,
      max: VueTypes.integer
    }).def({ min: 0, max: 360 })
  },
  data () {
    return {
      focusList: ['bildung', 'gesundheit', 'kultur', 'sport']
    }
  },
  computed: {
    enabled () {
      return process.env.USE_ARCS === 'true'
    },
    computedBorderColor () {
      const classPrefix = 'arc-el--'
      if (this.borderColor !== '') { return classPrefix + this.borderColor }
      const randomFocus = this.focusList[Math.floor(Math.random() * this.focusList.length)]
      return classPrefix + randomFocus
    },
    computedRotation () {
      if (this.rotation !== 0) { return this.rotation }
      return getRandomIntegerInRange(this.randomRangeRotation.min, this.randomRangeRotation.max)
    },
    computedPositionX () {
      if (this.positionX !== 0) { return this.positionX }
      if (Array.isArray(this.randomRangePositionX)) {
        const coordsArray = this.randomRangePositionX
        const coords = coordsArray[Math.floor(Math.random() * coordsArray.length)]
        return getRandomIntegerInRange(coords.min, coords.max)
      }
      return getRandomIntegerInRange(this.randomRangePositionX.min, this.randomRangePositionX.max)
    },
    computedPositionY () {
      if (this.positionY !== 0) { return this.positionY }
      return getRandomIntegerInRange(this.randomRangePositionY.min, this.randomRangePositionY.max)
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/colors';
@import 'beisheim/scss/scale';
@import 'beisheim/scss/breakpoints';

$border-size: 20;

.arc {
  position: absolute;
  top: -150px;
  left: 0;
  height: 100%;
  height: calc(100% + 300px);
  width: 100%;
  max-width: 100vw;
  z-index: -1;
  pointer-events: none;
  overflow: hidden;

  @include from(7) {
    overflow: visible;
  }
}
</style>
